
import React, { useState } from "react";
import ShopifyModal from "../../../components/ShopifyModal";

const Index = ({redeemData,setRedeemData,resetCallback}) => {
    const [saveLoading, setSaveLoading] = useState(false);
    const handleSave = async () => {
        setSaveLoading(true);
        resetCallback();
        setTimeout(() => {
          setSaveLoading(false);
        }, 2000);
      };
  return (
    <div className="upgrade_new_feature">
      <ShopifyModal id="redeem-coupon-modal"
        open={redeemData.open}
        onClose={() => 
          {
            setRedeemData((prevValue)=>({...prevValue,open:false}))
            setSaveLoading(false)
          }}
        heading={'Redeem Coupon'}
        primaryAction={{
          content: "Done",
          loading:saveLoading,
          onAction: () => {
            handleSave()
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => {
              setRedeemData((prevValue)=>({...prevValue,open:false}))
              setSaveLoading(false)
            }
          },
        ]}
      >
        <p style={{fontSize:'14px'}}>{`Are you sure you want to redeem ${redeemData.value} $${redeemData.coupon} discount coupons? This will cost ${redeemData.need * redeemData.value} points.`}</p>
        </ShopifyModal>
    </div>
  );
};

export default Index;
